module.exports = function() {
  return new Worker(__webpack_public_path__ + "public/ticket-system.js");
};